import {MigrationStep} from 'config-migration/types/MigrationStep';
import {CommonAnalyticsActions} from 'constants/AnalyticsConstants';

import {MigrationTab} from '../types/MigrationTab';
import {BaseConfigMigrationEventMetadata, trackCommonEvent} from './CommonConfigMigrationAnalytics';

// Metadata
export type ErrorToastEventMetadata = BaseConfigMigrationEventMetadata & {
  stage: MigrationTab;
  import_step?: MigrationStep;
  error_messages?: Array<string>;
};

// Functions
export function trackTriggeredConfigMigrationErrorToast(metadata: ErrorToastEventMetadata): void {
  trackCommonEvent(CommonAnalyticsActions.TRIGGERED_ERROR_TOAST, metadata);
}
